import { computed as s, toValue as l } from "vue";
import { onClickOutside as c, onKeyStroke as a } from "@vueuse/core";
import { offset as d, shift as u, flip as w } from "@floating-ui/vue";
import { usePopover as O } from "../usePopover/usePopover.mjs";
function C(t) {
  const { onClose: e, placement: r = "bottom", middleware: p, isOpen: i, ...n } = t, { floatingRef: f, referenceRef: o, style: m } = O({
    placement: r,
    middleware: s(() => l(p) || [d(8), u(), w()]),
    isOpen: i,
    ...n
  });
  return c(o, e), a("Escape", e, { target: o }), { floatingRef: f, referenceRef: o, style: m };
}
export {
  C as useDropdown
};
